// extracted by mini-css-extract-plugin
export default {"top":"LabTabs_top__UT+lP","names":"LabTabs_names__uvVT+","tabsName":"LabTabs_tabsName__UYEJL"};